import { __ } from "@libs/utilities"
import { Button, ButtonGroup, Dialog, Icon, Intent } from "@blueprintjs/core"
import { useState } from "react"
import { IAdminStore, useAdminStore } from "../../data/store"
import { getVisibleValue } from "@libs/layouts"
import { TableCheckBox } from "./DataTypeRow" 
import { DELETE_BULK_ACTION, GET_FEED_ACTION } from "@/modules/pe-basic-module/data/actionTypes"
import actions from "@/modules/pe-basic-module/data/actions"
import { IState, useMainStore } from "@/settings/zustand"
import { useParams } from "react-router"
import { ConfirmButton } from "@libs/useful"
import { DIALOG_SIZE } from "@libs/interfaces/layouts"
import { IBulk } from "../../data/interfaces"

 
const BulkDeleter = (props : any) : JSX.Element => {
    const {landId} = useParams()
    const [isLoading, setIsLoading]             = useState(false)
    const [isOpen, setOpen]                     = useState(false)
    const bulks: IBulk[]                        = useAdminStore((state:IAdminStore) => state.bulks)
    const items: any[]                          = useAdminStore((state:IAdminStore) => state.items)
    const offset: number                        = useAdminStore((state:IAdminStore) => state.offset) 
    const paging: string                        = useAdminStore((state:IAdminStore) => state.paging) 
    const pageCount: number                     = useMainStore( ( state: IState ) => state.pageCount )

    const setBulks: ((bulks: IBulk[]) => void)  = useAdminStore((state:IAdminStore) => state.setBulks) 
    const setItems: ((items: any[]) => void)    = useAdminStore( (state:IAdminStore) => state.setItems )

    const visibleValue:string = getVisibleValue(props.data_type)
    const onChange = (checked: boolean, _bulk: IBulk) => {
        setBulks(
            bulks.map(bulk => {
                if(bulk.id === _bulk.id) {
                    bulk.checked = checked
                }
                return bulk
            })
        )
    }
    const onFinallyDelete = () => {
        setOpen(false)
        setIsLoading( true )
        actions( DELETE_BULK_ACTION, { 
            id: bulks.filter(bulk => bulk.checked).map(bulk => bulk.id), 
            data_type : props.data_type,
            landId
        
        } )
            .then((response) => {
                setIsLoading( false )
                console.log(response)
                if(Array.isArray( response )) {
                    const bs: IBulk[] = [...bulks].filter( bulk => !response.map(r => r.id).includes(bulk.id) ) 
                    setBulks( bs )
                    const its: any[] = [...items].filter( item => !response.map(r => r.id).includes(item.id) ) 
                    setItems( its )
                }
                actions(
                    GET_FEED_ACTION, 
                    { 
                      data_type: props.data_type, 
                      offset, 
                      count: pageCount, 
                      paging,
                      land_id: landId 
                    })
                    .then( response2 => {
                        setItems(response2.feed)
                        setBulks( response2.feed.map((f: any) => ({
                            id: f.id,
                            checked: false,
                            data_type: props.data_type
                        })))
                    })
            })
    }
    return <ConfirmButton
        buttonLabel={__("Delete bulk items")}
        buttonIntent={Intent.DANGER}
        buttonClassName=" h-100 px-4"
        onConfirm={onFinallyDelete} 
        dialogClasssName={DIALOG_SIZE.LARGE}
        yesLabel={__("Yes, finally delete selected items")}
        noLabel={__("No")}
    >
        <div className="p-5 flex-centered flex-column overflow-y-auto max-height-350 height-350">
            <div className="">
            {
                bulks.map((bulk:IBulk, i:number) => {
                    const item: any = items.filter( item => item.id === bulk.id )[0]
                    const title: string = item ? item[visibleValue] : `${visibleValue} no title (${bulk.id})`
                    return <div key={bulk.id} className="d-flex align-items-center my-1">
                        <TableCheckBox 
                            {...props}
                            checked={ bulk.checked }
                            onChecked={(checked:boolean) => onChange(checked, bulk) }
                        /> 
                        <div className="">{ title }</div>    
                    </div>
                })
            }
            </div>
        </div>
    </ConfirmButton>
} 

export default BulkDeleter